module.exports = __webpack_public_path__ + "img/agile.0becbd91.svg";